import { Route, Routes } from "react-router-dom";
import { ChangePassword } from "../pages/ChangePassword/ChangePassword";
import CreateAccount from "../pages/createAccount/createAccount";
import ForgotPassword from "../pages/forgotPassword/forgotPassword";
import LevelOneLogin from "../pages/levelOne/levelOneLogin/levelOneLogin";
import Login from "../pages/login/login";
import VerificationPage from "../pages/verificationPage/verificationPage";
import ResubmitForm from "../pages/verificationPage/resubmitForm";
import ResetPassword from "../pages/resetPassword/resetPassword";
import CustomErrorPage from "../pages/CustomErrorPage/customErrorPage";

function OnboardingRoutes() {
  return (
    <Routes>
      <Route path="/onboarding/login" element={<Login />} />
      <Route path="/onboarding/forgot-password" element={<ForgotPassword />} />
      <Route path="/onboarding/reset-password" element={<ResetPassword />} />
      <Route path="/onboarding/create-account" element={<CreateAccount />} />
      <Route
        path="/onboarding/verification-page"
        element={<VerificationPage />}
      />
      <Route
        path="/onboarding/user-regestration-form"
        element={<ResubmitForm />}
      />
      <Route path="/onboarding/levelOneLogin" element={<LevelOneLogin />} />
      <Route path="/onboarding/change-password" element={<ChangePassword />} />
      <Route path="*" element={<CustomErrorPage errorCode={404} />} />

    </Routes>
  );
}

export default OnboardingRoutes;
